<template>
  <img src="@/assets/images/epos_loading_white.gif" style="width: 50px; height: 50px;" v-if="white" />
  <div class="loading-gif" v-else></div>
</template>

<script>
export default {
  props: ['white'],
};
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

.icon-loading {
  color: $secondary-bg-color;
}
</style>
